"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PendingPackages = void 0;
/* eslint-disable @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-unused-vars */
/* Package Imports */
var classnames_1 = __importDefault(require("classnames"));
var moment_1 = __importDefault(require("moment"));
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
/* Imported CSS */
require("./PendingPackages.scss");
var models_1 = require("@app/_state/models");
var PackageProgressBar_1 = require("@app/components/packages/PackageProgressBar");
var PauseButton_1 = require("@app/components/packages/PauseButton");
var RetryButton_1 = require("@app/components/packages/RetryButton");
var actions_1 = require("@app/features/package-details/state/actions");
var actions_2 = require("@app/features/transfers/state/actions");
var selectors_1 = require("@app/features/transfers/state/selectors");
var config_1 = require("@app/shared/config");
var constants_1 = require("@app/shared/constants");
var log_1 = __importDefault(require("@app/shared/log"));
var utils_1 = require("@app/shared/utils");
var api_1 = require("@server/types/api");
/**
 * Blast's Pending Upload Packages component, displays the status of the user's pending & recently completed package uploads
 */
var PendingPackages = /** @class */ (function (_super) {
    __extends(PendingPackages, _super);
    function PendingPackages() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /* Action functions - begin */
        _this.handleRetryTransfer = function (packageId, transferId) {
            if (_this.props.asperaEnabled) {
                _this.props.onResumeConnectTransfer(transferId);
            }
            else {
                _this.props.onRetryHttpUpload(packageId);
            }
        };
        _this.handleStopTransfer = function (pkg) {
            if (pkg.transferId) {
                _this.props.onStopConnectTransfer(pkg.transferId);
            }
            else {
                log_1.default.debug("Unable to stop transfer of '" + pkg.title + "' (" + pkg.packageId + ")");
            }
        };
        return _this;
    }
    /* Action functions - end */
    PendingPackages.prototype.render = function () {
        var _this = this;
        var _a = this.props, asperaEnabled = _a.asperaEnabled, packages = _a.packages;
        var minSentDate = moment_1.default().subtract(config_1.Config.RECEIVED_PACKAGES_HISTORY_LIMIT_IN_HOURS, 'hours');
        var retryIcon = asperaEnabled ? 'fa-play' : 'fa-sync';
        return (react_1.default.createElement("div", { className: "pending-packages" },
            react_1.default.createElement("h3", { className: "has-text-weight-bold" }, "Recently Sent"),
            react_1.default.createElement("div", { className: "table pending-uploads-table is-fullwidth" }, packages.map(function (pkg, i) {
                var isTransferComplete = pkg.state === models_1.PackageTransferState.COMPLETE;
                var handleOnPush = function (id) {
                    if (isTransferComplete) {
                        _this.props.onPush(id);
                    }
                };
                return (react_1.default.createElement("div", { key: pkg.title + "_" + pkg.creationDate, className: classnames_1.default('columns', 'is-mobile', { 'is-completed': isTransferComplete }), onClick: function () { return handleOnPush(pkg.packageId); } },
                    react_1.default.createElement("div", { className: "column is-0 td", onClick: utils_1.unclickable },
                        react_1.default.createElement("div", { className: classnames_1.default('has-text-centered') },
                            (pkg.state === models_1.PackageTransferState.IN_PROGRESS) && asperaEnabled &&
                                react_1.default.createElement(PauseButton_1.PauseButton, { disabled: false, onDownloadStop: function () { return _this.handleStopTransfer(pkg); }, showTooltip: true }),
                            pkg.retryable && (pkg.state === models_1.PackageTransferState.FAILED || pkg.state === models_1.PackageTransferState.STOPPED) && moment_1.default(pkg.creationDate).isAfter(minSentDate) &&
                                react_1.default.createElement(RetryButton_1.RetryButton, { disabled: false, icon: retryIcon, onDownload: function () { return _this.handleRetryTransfer(pkg.packageId, pkg.transferId); }, showTooltip: true, tooltipMessage: (asperaEnabled) ? 'Resume Transfer' : 'Retry Transfer' }))),
                    react_1.default.createElement("div", { className: classnames_1.default('column', 'is-3', 'td', 'is-resize', 'has-archive', 'has-text-weight-bold', 'package-state') },
                        react_1.default.createElement("p", { className: "help transfer-state-text" },
                            react_1.default.createElement("span", { className: "icon is-small" },
                                react_1.default.createElement("i", { className: "fas fa-rocket" })),
                            react_1.default.createElement("span", null, utils_1.getPackageTransferStateText(api_1.Direction.SEND, pkg.state, pkg.size === pkg.transferredBytes)),
                            pkg.transferredBytes > 0 && pkg.state !== models_1.PackageTransferState.COMPLETE &&
                                react_1.default.createElement("span", { className: "is-pulled-right" }, utils_1.getPercentComplete(pkg.transferredBytes, pkg.size))),
                        react_1.default.createElement(PackageProgressBar_1.PackageProgressBar, { className: 'is-upload', state: pkg.state, transferredBytes: pkg.transferredBytes, totalBytes: pkg.size })),
                    react_1.default.createElement("div", { className: classnames_1.default('column', 'is-4', 'td is-resize', 'has-archive', 'subject-title') }, pkg.title),
                    react_1.default.createElement("div", { className: classnames_1.default('column', 'is-3', 'td', 'is-variable', 'has-archive', 'package-date') },
                        react_1.default.createElement("span", { className: "tooltip", "data-tooltip": moment_1.default(pkg.creationDate).format(constants_1.DATE_TIME_FORMAT) }, moment_1.default(pkg.creationDate).fromNow())),
                    pkg.errorDesc &&
                        react_1.default.createElement("div", { className: "column is-12 td error-message" },
                            react_1.default.createElement("span", { className: "help is-danger" }, pkg.errorDesc))));
            })),
            react_1.default.createElement("p", { className: "has-text-weight-bold" },
                "To see more sent messages go to ",
                react_1.default.createElement(react_router_dom_1.Link, { to: "/dash/packages/history/sent", className: "has-text-info" }, "History."))));
    };
    return PendingPackages;
}(react_1.Component));
exports.PendingPackages = PendingPackages;
var mapStateToProps = function (store) {
    return {
        asperaEnabled: selectors_1.isAsperaEnabled(store),
        packages: store.pendingUploads.pendingUploads.valueSeq().toArray()
    };
};
var mapDispatchToProps = {
    onPush: actions_1.onPushToPkgDetails,
    onResumeConnectTransfer: actions_2.resumeConnectTransfer,
    onRetryHttpUpload: actions_2.retryHttpUpload,
    onStopConnectTransfer: actions_2.stopConnectTransfer
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(PendingPackages);
